import React, {} from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Example } from 'components';
import i18n from 'i18next';

const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: stretch;
	gap: 20px;
`;

const ExmapleBlockOrder = () => {
	const { t } = useTranslation();

	return (
		<>

			<Container>

				<Example url={'https://images.acase.ru/sjas/xmlgw/xsd/OrderRequest.xsd'} title={t('Схема запроса')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/xsd/OrderResponse.xsd'} title={t('Схема ответа')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/OrderRequest.xml'} title={t('Пример запроса') + ' ' + t('Размещение')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/OrderResponse.xml'} title={t('Пример успешного ответа') + ' ' + t('Размещение')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/OrderGainRequest.xml'} title={t('Пример запроса') + ' ' + t('Агентские договора с доп.выгодой')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/OrderResponse.xml'} title={t('Пример успешного ответа') + ' ' + t('Агентские договора с доп.выгодой')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/OrderRequest2.xml'} title={t('Пример запроса') + ' ' + t('Оплата в отеле')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/OrderResponse2.xml'} title={t('Пример успешного ответа') + ' ' + t('Оплата в отеле')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/OrderResponseError.xml'} title={t('Пример ответа с ошибкой')}/>

			</Container>
		</>
	);
};

export default ExmapleBlockOrder;